import { createContext } from "react";

const defaultValue = {
  isLoaderShown: false,
  setIsLoaderShown: (bool) => bool,
  isIDPInitialized: false,
  user: null,
  language: null,
  menuItems: [],
  setMenuItems: () => null,
  noMenuPages: {},
  setGlobalSurvey: () => {},
  survey: {},
  loginUrl: "",
};
const GlobalContext = createContext(defaultValue);
export default GlobalContext;
